// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cYL6","fullView":"styles_fullView__1rqcA"};